import React from "react";
import cx from "classnames";


export const GroupedSelectMenu = ({
    matchingItems,
    getMenuProps,
    getItemProps,
    highlightedIndex,
    selectedItems,
    itemToString,
    multi
}) => {
    return (
        <ul {...getMenuProps({className: "menu"})}>
            {matchingItems.reduce((result, section) => {
                result.sections.push(
                    <React.Fragment key={section.label}>
                        <li className="divider" data-content={section.label} key={section.label}/>
                        {section.items.map((item) => {
                            const index = result.itemIndex++;
                            return (
                                <li {...getItemProps({key: item._id, item, index, className: "menu-item"})}>
                                    <a className={cx(
                                        {"active": highlightedIndex === index},
                                        {'text-bold': multi ? selectedItems.find(i => i._id === item._id) : (selectedItems && selectedItems._id === item._id)}
                                    )}>
                                        {itemToString(item)}
                                    </a>
                                </li>
                            )
                        })}
                    </React.Fragment>
                );
                return result;
            }, {sections: [], itemIndex: 0}).sections}
        </ul>
    );
};


export const PlainSelectMenu = ({
    matchingItems,
    getMenuProps,
    getItemProps,
    highlightedIndex,
    selectedItems,
    itemToString,
    multi
}) => {
    return (
        <ul {...getMenuProps({className: "menu"})}>
            {matchingItems.map((item, index) => (
                <li {...getItemProps({key: item._id, item, index, className: "menu-item"})}>
                    <a className={cx(
                        {"active": highlightedIndex === index},
                        {'text-bold': multi ? selectedItems.find(i => i._id === item._id) : (selectedItems && selectedItems._id === item._id)}
                    )}>
                        {itemToString(item)}
                    </a>
                </li>
            ))}
        </ul>
    )
};